import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { RouteHistoryItem } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class NavService {
  pageTitle: string = 'Rental Equipment';
  showBackButton: boolean = false;
  backButtonRoute: string = '';
  backButtonRouteParams: Array<string> = [];
  currentRoute: string = '';
  searchBackButtonRoute: string = '';
  showSearchbar = true;
  showFilters = false;

  constructor(
    public router: Router,
    public route: ActivatedRoute
  ) {}

  routeHistory: Array<RouteHistoryItem> = [];

  clearRouteHistory = () => {
    this.routeHistory = [];
  };

  goBack() {
    this.backButtonRoute = '';
    const routeHistoryLength = this.routeHistory.length;
    if (routeHistoryLength > 1) {
      this.backButtonRoute = this.routeHistory[routeHistoryLength - 2].Url;
      this.pageTitle = this.routeHistory[routeHistoryLength - 2].PageTitle;
      this.routeHistory.pop();
      this.router.navigate([this.backButtonRoute]);
    }
  }
}
